import { EcommerceSectionNamespace } from '../model';

export const getButtonCheckoutInteraction = (
  isSticky: boolean,
  needScroll: boolean,
): EcommerceSectionNamespace.EEcommerceInteraction => {
  if (isSticky) {
    return EcommerceSectionNamespace.EEcommerceInteraction.BUTTON_CHECKOUT_STICKY;
  }
  if (needScroll) {
    return EcommerceSectionNamespace.EEcommerceInteraction.BUTTON_CHECKOUT_DOWN_SCROLL;
  }
  return EcommerceSectionNamespace.EEcommerceInteraction.BUTTON_CHECKOUT;
};
